import { AppProps } from "next/app";
import Head from "next/head";
import { useEffect } from "react";
import Modal from "react-modal";

import "@uppy/core/dist/style.css";
import "@uppy/file-input/dist/style.css";
import "@uppy/progress-bar/dist/style.css";

import "../src/themes/browserOverrides.css";
import "../src/themes/customClasses.css";
import "../src/themes/effects.css";
import "../src/themes/fonts.css";
import "../src/themes/light.css";
import "../src/themes/materialIcons.css";
import "../src/themes/overrides.css";
import "../src/themes/tachyons.css";
import "../src/themes/toggle.css";

import Providers from "../src/components/Providers";

const MyApp = ({ Component, pageProps }: AppProps) => {
  useEffect(() => {
    // [RWS] prevent warnings caused by react-modal:
    // Warning: react-modal: App element is not defined. Please use `Modal.setAppElement(el)` or set `appElement={el}`. This is needed so screen readers don't see main content when modal is opened. It is not recommended, but you can opt-out by setting `ariaHideApp={false}`.
    Modal.setAppElement("#__next");
  }, []);

  return (
    <>
      <Head>
        <meta
          name={"viewport"}
          content={
            "width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"
          }
        />
      </Head>
      <Providers>
        <Component {...pageProps} />
        <style jsx global>{`
          #__next {
            display: flex;
            flex-direction: column;
          }
        `}</style>
      </Providers>
    </>
  );
};

export default MyApp;
